export interface Dictionary<T> {
    [key: string]: T
}

export function fromList<T>(items: [string, T][]): Dictionary<T> {
    const dictionary = {}
    for (const [key, value] of items) {
        dictionary[key] = value
    }
    return dictionary
}

export function toList<T>(dictionary: Dictionary<T>): [string, T][] {
    const items: [string, T][] = []
    for (const key in dictionary) {
        if (dictionary.hasOwnProperty(key)) {
            items.push([key, dictionary[key]])
        }
    }
    return items
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/Dictionary.ts